function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useAtomValue } from 'jotai';
import { useLoaderData } from 'react-router-dom';
import uniqueID from "../../../../../../shared/uniqueID";
import { Translate } from "../../../../../I18N";

import { Button, Card, Sidepanel } from "../../../../Components/UI";
import { InputField, MultiSelect } from "../../../../Components/Forms";
import { sidepanelAtom } from "./sidepanelAtom";









const FiltersSidepanel = ({
  showSidepanel,
  setShowSidepanel,
  onSave,
  availableTemplates
}) => {var _filter$subRows, _errors$name;
  const { templates: allTemplates } = useLoaderData();
  const filter = useAtomValue(sidepanelAtom);
  const multiselectValues = filter === null || filter === void 0 ? void 0 : (_filter$subRows = filter.subRows) === null || _filter$subRows === void 0 ? void 0 : _filter$subRows.map((item) => item.id).filter((v) => v);



  const selectedValues = [];
  const selectedOptions =
  (multiselectValues === null || multiselectValues === void 0 ? void 0 : multiselectValues.map((value) => {
    const template = allTemplates.find((t) => t._id === value);
    selectedValues.push(template === null || template === void 0 ? void 0 : template._id);
    return {
      label: template === null || template === void 0 ? void 0 : template.name,
      value: template === null || template === void 0 ? void 0 : template._id
    };
  })) || [];

  const availableOptions = availableTemplates === null || availableTemplates === void 0 ? void 0 : availableTemplates.map((availableTemplate) => ({
    label: availableTemplate.name,
    value: availableTemplate._id
  }));

  const defaultValues = _objectSpread(_objectSpread({}, filter), {}, { subRows: selectedValues, rowId: (filter === null || filter === void 0 ? void 0 : filter.rowId) || 'NEW' });
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues,
    values: defaultValues
  });

  const closeSidepanel = () => {
    setShowSidepanel(false);
    reset();
  };

  const formatSelected = (selected) =>
  selected === null || selected === void 0 ? void 0 : selected.map((selection) => {var _allTemplates$find;
    const templateName = allTemplates === null || allTemplates === void 0 ? void 0 : (_allTemplates$find = allTemplates.find((template) => template._id === selection)) === null || _allTemplates$find === void 0 ? void 0 : _allTemplates$find.name;
    return { id: selection, name: templateName, rowId: selection };
  });

  const handleSave = (values) => {
    const result = _objectSpread(_objectSpread({}, values), {}, { subRows: formatSelected(values.subRows) });

    if (!(filter !== null && filter !== void 0 && filter._id)) delete result._id;
    if (!(filter !== null && filter !== void 0 && filter.id)) result.id = uniqueID();
    if (result.rowId === defaultValues.rowId) result.rowId = uniqueID();

    onSave(result);
    closeSidepanel();
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      withOverlay: true,
      isOpen: showSidepanel,
      closeSidepanelFunction: () => closeSidepanel(),
      title: filter !== null && filter !== void 0 && filter.name ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit group") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add group") }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(handleSave), id: "group-edit-form" }, void 0, /*#__PURE__*/
    React.createElement("input", _extends({ className: "hidden" }, register('_id'))), /*#__PURE__*/
    React.createElement("input", _extends({ className: "hidden" }, register('id'))), /*#__PURE__*/
    React.createElement("input", _extends({ className: "hidden" }, register('rowId'))), /*#__PURE__*/

    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "General Information"), className: "mb-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Name"),
      id: "group-name" },
    register('name', {
      required: true
    }), {
      errorMessage:
      ((_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.type) === 'required' && /*#__PURE__*/_jsx(Translate, {}, void 0, "This field is required") })

    )
    ), /*#__PURE__*/

    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Entity types"), className: "mb-4" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx(Controller, {
      control: control,
      name: "subRows",
      render: ({ field: { onChange, value } }) => /*#__PURE__*/
      _jsx(MultiSelect, {
        label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Entity types"),
        options: [...(selectedOptions || []), ...(availableOptions || [])],
        value: value || [],
        onChange: onChange }
      ) }

    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      className: "flex-grow",
      type: "button",
      styling: "outline",
      onClick: () => {
        closeSidepanel();
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "submit", form: "group-edit-form" }, void 0,
    filter !== null && filter !== void 0 && filter.id ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Update") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add")
    )
    )
    )
    ));

};

export { FiltersSidepanel };